var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-12 overflow-y-auto h-full" },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass:
            "mx-4 lg:mx-24 xl:mx-64 py-8 text-center lg:py-16 border-y",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "customer-grid hidden lg:grid items-stretch gap-4 mt-6 text-base text-left",
            },
            _vm._l(_vm.users, function (item) {
              return _c(
                "div",
                { key: item.title, staticClass: "min-w-0 flex flex-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "customer-card-wrap flex flex-1 flex-col min-w-0",
                    },
                    [
                      item.url
                        ? _c(
                            "a-tooltip",
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(" 点击查看详情 "),
                              ]),
                              _c(
                                "a-card",
                                {
                                  staticClass: "customer-card",
                                  attrs: { title: item.title },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPage(item.url)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "font-[600] customer-desc" },
                                    [_vm._v(_vm._s(item.desc))]
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        : _c(
                            "a-card",
                            {
                              staticClass: "customer-card",
                              attrs: { title: item.title },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "font-[600] customer-desc" },
                                [_vm._v(_vm._s(item.desc))]
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "flex flex-col lg:hidden justify-center mt-0" },
            _vm._l(_vm.users, function (item) {
              return _c(
                "a-row",
                {
                  key: item.title,
                  staticClass: "mt-6",
                  staticStyle: { width: "100%" },
                },
                [
                  item.url
                    ? _c(
                        "a-card",
                        {
                          staticClass: "customer-card",
                          attrs: { title: item.title },
                          on: {
                            click: function ($event) {
                              return _vm.openPage(item.url)
                            },
                          },
                        },
                        [
                          _c("p", { staticClass: "font-[600]" }, [
                            _vm._v(_vm._s(item.desc)),
                          ]),
                        ]
                      )
                    : _c(
                        "a-card",
                        {
                          staticClass: "customer-card",
                          attrs: { title: item.title },
                        },
                        [
                          _c("p", { staticClass: "font-[600]" }, [
                            _vm._v(_vm._s(item.desc)),
                          ]),
                        ]
                      ),
                ],
                1
              )
            }),
            1
          ),
        ]
      ),
      _c("home-page-to-contact"),
      _c("home-page-contact"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "px-4 lg:px-32 pb-16 pt-20 text-left lg:pt-32 bg-center bg-[linear-gradient(180deg,#d1f2fd,rgba(209,242,253,0))]",
      },
      [
        _c(
          "h1",
          {
            staticClass:
              "font-display text-xl xl:text-2xl 2xl:text-4xl sm:text-4xl font-bold tracking-tight text-slate-900",
          },
          [_vm._v(" 专注于中小型非标机械厂的生产管理软件系统 ")]
        ),
        _c(
          "h3",
          {
            staticClass:
              "mt-12 text-base lg:text-xl tracking-wide text-slate-700",
          },
          [_vm._v(" 轻松解决中小型非标机械厂订单交期与库存管理难题 ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }